import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CentralClienteRetornoRoutingModule } from './central-cliente-retorno-routing.module';
import { CentralClienteRetornoComponent } from './central-cliente-retorno.component';
import { FormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { DividerModule } from 'primeng/divider';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { MessagesModule } from 'primeng/messages';
import { TooltipModule } from 'primeng/tooltip';
import { CalendarModule } from 'primeng/calendar';
import { DialogModule } from 'primeng/dialog';
import { InputTextareaModule } from 'primeng/inputtextarea';


@NgModule({
  declarations: [
    CentralClienteRetornoComponent
  ],
  imports: [
    CommonModule,
    CentralClienteRetornoRoutingModule,
    FormsModule,
    TableModule,
    ButtonModule,
    InputTextModule,
    DropdownModule,
    DividerModule,
    ProgressSpinnerModule,
    MessagesModule,
    TooltipModule,
    CalendarModule,
    DialogModule,
    InputTextareaModule
  ]
})
export class CentralClienteRetornoModule { }
